import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA }
	from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf } from '@angular/common';

@Component({
	selector: 'copo-snackbar-save-draft-guarantee',
	templateUrl: './snackbar-save-draft-guarantee.component.html',
	styleUrl: './snackbar-save-draft-guarantee.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [NgIf, TranslateModule]
})
export class SnackbarSaveDraftGuaranteeComponent {
	constructor(
		private readonly snackBarRef: MatSnackBarRef<SnackbarSaveDraftGuaranteeComponent>,
		@Inject(MAT_SNACK_BAR_DATA) public errorOccured: boolean
	) {}

	dismiss() {
		this.snackBarRef.dismiss();
	}
}
